import {array} from "../../Core/Reflection";
import {AssemblyBody, AssemblyItem} from "./AssemblyItem";
import {Assembly} from "./Assembly";
import {MonsterSlot, MonsterSlots} from "./MonsterModel";

export class Monster extends Assembly<MonsterSlot> {

    readonly [MonsterSlot.Body] = array(() => this.addChild(new AssemblyBody(MonsterSlot.Body)));
    readonly [MonsterSlot.Head] = array(() => this.addChild(new AssemblyItem(MonsterSlot.Head)));
    readonly [MonsterSlot.BackLegs] = array(() => this.addChild(new AssemblyItem(MonsterSlot.BackLegs)));
    readonly [MonsterSlot.FrontLegs] = array(() => this.addChild(new AssemblyItem(MonsterSlot.FrontLegs)));

    constructor() {
        super(MonsterSlots);
    }

    onLayout() {
        super.onLayout();
        [...this[MonsterSlot.BackLegs], ...this[MonsterSlot.FrontLegs]].forEach(item => {
            if (item.textureName) {
                item.zIndex = item.textureName.indexOf("back") >= 0 ? 0 : -1;
            }
        });
    }

    protected getBodyItems(): AssemblyBody<MonsterSlot>[] {
        return this[MonsterSlot.Body];
    }

    protected getSlotItems(slot: MonsterSlot): AssemblyItem<MonsterSlot>[] {
        return this[slot];
    }

    setSlot(slot: MonsterSlot, value?: number) {
        super.setSlot(slot, value ?? 0);
    }

    nextSlot(slot: MonsterSlot) {
        super.nextSlot(slot);
        if (this.getSlot(slot) === 0) {
            super.nextSlot(slot);
        }
    }
}